import PropTypes from 'prop-types';
import styles from './priceBox.module.css';

const PriceBox = (props) => {
  const {
    title,
    content,
    price,
  } = props;

  return (
    <div className={styles.box}>
      <div className={styles.info}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{content}</div>
      </div>
      <div className={styles.price}>{price}</div>
    </div>
  );
};

PriceBox.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  price: PropTypes.string,
};

export default PriceBox;
